import { Component, OnInit } from '@angular/core';
import { ImpersonationService } from '../../service/impersonation.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'nio-impersonation-banner',
    templateUrl: './impersonation-banner.component.html',
    styleUrl: './impersonation-banner.component.scss',
    imports: [CommonModule, MatIconModule, MatButtonModule]
})
export class ImpersonationBannerComponent implements OnInit {
  constructor(public imp: ImpersonationService) {}
  ngOnInit(): void {}
}
